import React, { useState } from "react";
import { IoEye, IoEyeOff } from "react-icons/io5";

const CustomInput = ({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  required = false,
  minLength,
  maxLength,
  showToggle = false,
  widthPercentage = 100,
  error = "",
  disabled = false,
  byDefaultDisabled = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputType =
    showToggle && type === "password"
      ? showPassword
        ? "text"
        : "password"
      : type;

  const toggleVisibility = () => setShowPassword((prev) => !prev);

  return (
    <div className="relative mb-2" style={{ width: `${widthPercentage}%` }}>
      <label htmlFor={id} className="block text-gray-700 mb-1">
        {label}
      </label>

      <div className="relative">
        <input
          id={id}
          type={inputType}
          value={value}
          onChange={(e) => {
            let inputVal = e.target.value;

            if (type === "tel") {
              inputVal = inputVal.replace(/[^0-9]/g, "");
            }

            if (type === "email") {
              if (!inputVal.includes("@")) {
              }
            }

            if (type === "text") {
              inputVal = inputVal.replace(/[0-9]/g, "");
            }

            onChange({ ...e, target: { ...e.target, value: inputVal } });
          }}
          placeholder={placeholder}
          required={required}
          minLength={minLength}
          maxLength={maxLength}
          disabled={disabled || byDefaultDisabled}
          // inputMode={type === "number" ? "numeric" : undefined}
          // pattern={type === "number" ? "[0-9]*" : undefined}
          className={`w-full p-3 h-[2.8rem] text-sm pr-10 ${
            disabled || byDefaultDisabled ? "bg-gray-50" : "bg-transparent"
          } border rounded-lg shadow-none focus:outline-none focus:ring-1 ${
            error
              ? "border-red-500 focus:ring-red-500"
              : "border-gray-300 focus:ring-black"
          }`}
        />

        {showToggle && type === "password" && (
          <button
            type="button"
            onClick={toggleVisibility}
            className="absolute right-5 top-1/2 transform -translate-y-1/2 text-gray-500 focus:outline-none"
            tabIndex={-1}
          >
            {showPassword ? (
              <IoEyeOff className="text-xl" />
            ) : (
              <IoEye className="text-xl" />
            )}
          </button>
        )}
      </div>

      {error && <p className="text-sm text-red-600 mt-1 ml-1">{error}</p>}
    </div>
  );
};

export default CustomInput;
